const regAlphabets = /^[A-Za-z\s]+$/
export default regAlphabets
